import { authorizedRequest } from 'api'
import { StudentCreateFormValues, TeacherCreateFormValues } from 'types'
import { ErrorProp } from './'

type CreateResponseProps =
  | {
      success: true
      id: string
    }
  | {
      success: false
      error: ErrorProp
      message?: string
      code?: string
      data?: { existing?: Record<string, unknown> }
    }

export type CreateProps = {
  formData?: Omit<StudentCreateFormValues, 'status'> & TeacherCreateFormValues
}

export async function create({
  formData,
}: CreateProps): Promise<CreateResponseProps> {
  try {
    const endpoint = `user`
    const response = await authorizedRequest({
      endpoint,
      method: 'POST',
      body: formData,
    })

    const json = (await response.json()) as CreateResponseProps

    if (json.success) {
      const { success, id } = json
      return { success, id }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
        code: (json as { code?: string }).code,
        data: (json as { data?: { existing?: Record<string, unknown> } }).data,
      }
    }
  } catch (e: any) {
    throw e
  }
}
